import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FilePreviewModal = ({ open, onClose, fileUrl, fileName }) => {
  const isPDF = fileUrl?.endsWith(".pdf");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">{fileName || "Preview File"}</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isPDF ? (
          <iframe
            src={fileUrl}
            title="PDF Preview"
            width="100%"
            height="500px"
            style={{ border: "none" }}
          />
        ) : (
          <img
            src={fileUrl}
            alt="Uploaded File"
            style={{ width: "100%", height: "auto" }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewModal;
